// Module
var code = "<div uib-accordion-group is-open=\"$ctrl.isOpen\" ng-class=\"{'accordion-invalid': !$ctrl.validation && $ctrl.validation !== undefined }\" class=\"panel-default\"> <uib-accordion-heading> <span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"{{$ctrl.header}}\"></span> </uib-accordion-heading> <div ng-transclude></div> </div> ";
// Exports
module.exports = code;